if ($('.section--services')[0]) {

    $( window ).on( "load", function() {
        if (location.hash) {
            var uri = location.hash.toString().replace('#', '');
        
            var services_filter = $('.services--filter[data-slug="' + uri + '"]').data('active');
            var services_promo = $('.services--filter[data-slug="' + uri + '"]').data('promo');
            var services_id = $('.services--filter[data-slug="' + uri + '"]').data('filter');
            var color = $('.services--filter[data-slug="' + uri + '"]').data('color');
            var blur = $('.services--filter[data-slug="' + uri + '"]').data('blur');
            var thisNav = $('.services--filter[data-slug="' + uri + '"]');
        
            changeService(services_filter, services_promo, services_id, color, blur, thisNav );
        }
    });


    $('.services--filter').click(function () {
        var services_filter = $(this).data('active');
        var services_promo = $(this).data('promo');
        var services_id = $(this).data('filter');
        var color = $(this).data('color');
        var blur = $(this).data('blur');
        var thisNav = $(this);

        changeService(services_filter, services_promo, services_id, color, blur, thisNav );
    });  
}


function changeService(services_filter, services_promo, services_id, color, blur, thisNav){
    $('.services--filter').removeClass('active');
    $(thisNav).addClass('active');

    $('.services--filter--grid').data('service', services_id);
    $('.services--filter--grid').removeClass('filter--green filter--blue filter--pink filter--orange').addClass('filter--' + color);
    $('.page-template-page-services').removeClass('filter--green filter--blue filter--pink filter--orange').addClass('filter--' + color);
    $('.section--services .section--bg--blur').removeClass('filter--green filter--blue filter--pink filter--orange filter-- blur--greencyan').addClass('filter--' + blur);
    $('.section--services .blur--one').removeClass('green blue pink orange').addClass(blur);

    $('.section--services .black--card--wrap').each(function () {
        if ($(this).data('activeid') == services_id) {
            $(this).removeClass('hidden').addClass('flex');
        } else {
            $(this).addClass('hidden').removeClass('flex');
        }
    });
    $('.services--filter--item').each(function () {
        var services_item = $(this).data('term').toString();
        if(jQuery.inArray(services_item, services_promo) === -1 && jQuery.inArray(services_item, services_filter) === -1) {
            $(this).removeClass('active--promo active--feature');
            $(this).find('.promo--text').addClass('hidden');
        } else if(jQuery.inArray(services_item, services_promo) === -1){
            $(this).removeClass('active--promo').addClass('active--feature');
            $(this).find('.promo--text').addClass('hidden');
        } else {
            $(this).addClass('active--promo active--feature');
            $(this).find('.promo--text').removeClass('hidden');
        }
    });
}